import {
  Baby,
  BookOpen, Cake, CalendarDays, Camera,
  Car,
  Check, Circle, ClipboardList, Clock, Container, File,
  FileText, Folder,
  Fuel, Gift,
  GraduationCap, IdCard, Key, Leaf, Lightbulb, Link, ListChecks,
  type LucideIcon, Navigation, Newspaper,
  PartyPopper, PenLine,
  Smartphone,
  Smile, SprayCan, ThumbsUp, Timer, Trophy, Type,
  User, Zap
} from "lucide-react";

export const ICON_BY_NAME: Record<string, LucideIcon> = {
  person: User,
  carwash: Car,
  smartphone: Smartphone,
  checkmark: Check,
  celebration: PartyPopper,
  smile: Smile,
  training: GraduationCap,
  school: GraduationCap,
  'fuel station': Fuel,
  document: FileText,
  clipboard: ClipboardList,
  gps: Navigation,
  leaf: Leaf,
  eco: Leaf,
  clock: Clock,
  'stylus note': PenLine,
  'quick reference': BookOpen,
  'calendar month': CalendarDays,
  cake: Cake,
  'rewarded ads': Gift,
  mop: SprayCan,
  'thumb up': ThumbsUp,
  checklist: ListChecks,
  container: Container,
  'id card': IdCard,
  'emoji objects': Lightbulb,
  news: Newspaper,
  'escalator warning': Baby,
  'minor crash': Car,
  'photo camera': Camera,
  file: File,
  text: Type,
  url: Link,
  folder: Folder,
  leaderboard: Trophy,
  timetracker: Timer,
  key: Key,
  circle: Circle,
}

export function iconForName(
  iconName: string | null | undefined,
  fallback: LucideIcon = Zap,
): LucideIcon {
  if (!iconName) return fallback
  return ICON_BY_NAME[iconName.trim().toLowerCase()] ?? fallback
}
